import React, { useEffect, useMemo, useRef, useState } from "react";
import { Play, Hand, Eraser } from "lucide-react";
import { TracingCanvas } from "@/components/tracing/TracingCanvas";
import { traceableFromConfig } from "@/data/printGeometry";

// Tutorial "demo" step: animated letter/stroke formation with an optional
// finger-try mode (no scoring — that happens in the practice trace engine).
export default function TraceDemo({ trace, color = "#0D9488" }) {
  const traceable = useMemo(() => traceableFromConfig(trace), [trace?.kind, trace?.text, trace?.style]); // eslint-disable-line react-hooks/exhaustive-deps
  const canvasRef = useRef(null);
  const animatorRef = useRef(null);
  const [tryIt, setTryIt] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => animatorRef.current?.play(), 500);
    return () => clearTimeout(t);
  }, [traceable]);

  if (!traceable) return null;
  const label = (trace.text || "").replace(/_/g, " ");

  return (
    <div className="mt-4" data-testid="trace-demo">
      <div className="mx-auto max-w-md rounded-3xl border-2 border-[#E5DECF] bg-white p-2">
        <TracingCanvas ref={canvasRef} letter={traceable} animatorRef={animatorRef}
          guideOpacity={tryIt ? 0.35 : 0.5} showStart showLetterGuide drawingEnabled={tryIt} />
      </div>
      <div className="mt-3 flex flex-wrap items-center justify-center gap-2">
        <button onClick={() => animatorRef.current?.replay()} data-testid="demo-watch"
          className="inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-heading font-bold text-white" style={{ background: color }}>
          <Play size={15} /> Watch again
        </button>
        <button onClick={() => { setTryIt((v) => !v); canvasRef.current?.clear(); }} data-testid="demo-try"
          className={`inline-flex items-center gap-1.5 rounded-full border-2 px-4 py-2 text-sm font-heading font-bold ${tryIt ? "border-[#F59E0B] bg-[#F59E0B]/10 text-[#B45309]" : "border-[#E5DECF] bg-white text-[#1F2937] hover:bg-[#F2ECE1]"}`}>
          <Hand size={15} /> {tryIt ? "Finger tracing on" : `Try ${label} with your finger`}
        </button>
        {tryIt && (
          <button onClick={() => canvasRef.current?.clear()} data-testid="demo-clear"
            className="inline-flex items-center gap-1.5 rounded-full border-2 border-[#E5DECF] bg-white px-3 py-2 text-sm font-heading font-bold text-[#1F2937] hover:bg-[#F2ECE1]"><Eraser size={15} /> Clear</button>
        )}
      </div>
    </div>
  );
}
